export default __webpack_public_path__ + "static/media/ic-send.f8cc4750.svg";